import Number from "./number";
import { Row } from "antd";
import { NumberChartData } from "./types";

/**
 * Display a number value for each dataset in the chart.
 */
export default function NumberChart({ data }: { data: NumberChartData }) {
  return (
    <div className="numberChart">
      <Row>
        {data.data.map((dataset) => (
          <Number
            dataset={dataset}
            snapshotsAmount={data.data.length}
            key={dataset.label}
          />
        ))}
      </Row>
    </div>
  );
}
